enum AuthRoutesEnum {
  'RESET_PASSWORD' = '/auth/reset-password',
  'ACTIVATE_ACCOUNT' = '/auth/activate-account',
}

export default AuthRoutesEnum
